export const MAX_DAY_WIDTH = 25;
